// GÖVDELİ BİTKİLER PART 1 - bitkiVeritabani1.js
// Low Tech + Mid Tech Başlangıç (44 bitki)

export const govdeliBitkilerPart1 = [
  // ==================== LOW TECH ====================
  {
    id: 'egeria-densa',
    isim: 'Elodea (Su Vebası)',
    latince: 'Egeria densa',
    resim: '/images/bitkiler/egeria-densa.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Güney Amerika',
    uzunluk: '30-100 cm',
    genislik: '3-5 cm',
    sicaklik: '10-26°C',
    ph: '6.0-9.0',
    sertlik: 'Yumuşak - Çok sert',
    isikIhtiyaci: 'Düşük',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Çok hızlı',
    bakimZorlugu: 'Çok kolay',
    konum: 'Arka plan',
    aciklama: 'Başlangıç için ideal, çok dayanıklı ve hızlı büyüyen bitki. Nitrat ve fosfat emiliminde çok etkili.'
  },
  {
    id: 'ceratophyllum-demersum',
    isim: 'Tilki Kuyruğu',
    latince: 'Ceratophyllum demersum',
    resim: '/images/bitkiler/ceratophyllum-demersum.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Kozmopolit',
    uzunluk: '30-150 cm',
    genislik: '5-10 cm',
    sicaklik: '10-30°C',
    ph: '6.0-9.0',
    sertlik: 'Yumuşak - Çok sert',
    isikIhtiyaci: 'Düşük',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Çok hızlı',
    bakimZorlugu: 'Çok kolay',
    konum: 'Yüzen / Arka plan',
    aciklama: 'Kökü olmayan, serbest yüzen bitki. Akvaryumda nitrat kontrolü için mükemmel.'
  },
  {
    id: 'elodea-canadensis',
    isim: 'Kanada Su Vebası',
    latince: 'Elodea canadensis',
    resim: '/images/bitkiler/elodea-canadensis.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Kuzey Amerika',
    uzunluk: '30-100 cm',
    genislik: '2-4 cm',
    sicaklik: '10-25°C',
    ph: '6.5-8.5',
    sertlik: 'Yumuşak - Sert',
    isikIhtiyaci: 'Düşük',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Hızlı',
    bakimZorlugu: 'Çok kolay',
    konum: 'Arka plan',
    aciklama: 'Soğuk suya dayanıklı, başlangıç akvaryumları için ideal.'
  },
  {
    id: 'bacopa-caroliniana',
    isim: 'Bacopa',
    latince: 'Bacopa caroliniana',
    resim: '/images/bitkiler/bacopa-caroliniana.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Kuzey Amerika',
    uzunluk: '20-40 cm',
    genislik: '3-5 cm',
    sicaklik: '20-28°C',
    ph: '6.0-8.0',
    sertlik: 'Yumuşak - Sert',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Yavaş - Orta',
    bakimZorlugu: 'Kolay',
    konum: 'Orta - Arka plan',
    aciklama: 'Limon kokulu yaprakları ile tanınır. Düşük ışıkta bile yaşar.'
  },
  {
    id: 'bacopa-monnieri',
    isim: 'Brahmi',
    latince: 'Bacopa monnieri',
    resim: '/images/bitkiler/bacopa-monnieri.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Asya, Afrika, Amerika',
    uzunluk: '15-30 cm',
    genislik: '2-4 cm',
    sicaklik: '22-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Kolay',
    konum: 'Orta plan',
    aciklama: 'Tıbbi bitki olarak da bilinen, dayanıklı bir tür.'
  },
  {
    id: 'bacopa-australis',
    isim: 'Avustralya Bacopası',
    latince: 'Bacopa australis',
    resim: '/images/bitkiler/bacopa-australis.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Güney Amerika',
    uzunluk: '10-30 cm',
    genislik: '3-5 cm',
    sicaklik: '20-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Opsiyonel',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Kolay',
    konum: 'Ön - Orta plan',
    aciklama: 'Yatay büyüme eğilimi gösterir, zemin kaplama için uygundur.'
  },
  {
    id: 'hygrophila-polysperma',
    isim: 'Zeytin Bitkisi',
    latince: 'Hygrophila polysperma',
    resim: '/images/bitkiler/hygrophila-polysperma.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Güneydoğu Asya',
    uzunluk: '25-50 cm',
    genislik: '6-10 cm',
    sicaklik: '20-30°C',
    ph: '6.0-8.0',
    sertlik: 'Yumuşak - Sert',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Çok hızlı',
    bakimZorlugu: 'Çok kolay',
    konum: 'Arka plan',
    aciklama: 'En dayanıklı bitkilerden biri. Her koşulda yaşar.'
  },
  {
    id: 'hygrophila-polysperma-rosanervig',
    isim: 'Pembe Zeytin',
    latince: 'Hygrophila polysperma Rosanervig',
    resim: '/images/bitkiler/hygrophila-polysperma-rosanervig.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Güneydoğu Asya (Kültür formu)',
    uzunluk: '20-40 cm',
    genislik: '5-8 cm',
    sicaklik: '20-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta',
    co2Ihtiyaci: 'Opsiyonel',
    buyumeHizi: 'Hızlı',
    bakimZorlugu: 'Kolay',
    konum: 'Orta - Arka plan',
    aciklama: 'Pembe damarlı yaprakları ile dikkat çeker. Güçlü ışıkta rengi belirginleşir.'
  },
  {
    id: 'hygrophila-corymbosa',
    isim: 'Limon Bitkisi',
    latince: 'Hygrophila corymbosa',
    resim: '/images/bitkiler/hygrophila-corymbosa.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Güneydoğu Asya',
    uzunluk: '25-50 cm',
    genislik: '10-15 cm',
    sicaklik: '20-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Hızlı',
    bakimZorlugu: 'Kolay',
    konum: 'Arka plan',
    aciklama: 'Geniş yapraklı, hızlı büyüyen güçlü bitki.'
  },
  {
    id: 'hygrophila-corymbosa-angustifolia',
    isim: 'Dar Yapraklı Limon',
    latince: 'Hygrophila corymbosa Angustifolia',
    resim: '/images/bitkiler/hygrophila-corymbosa-angustifolia.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Güneydoğu Asya',
    uzunluk: '30-60 cm',
    genislik: '8-12 cm',
    sicaklik: '22-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Hızlı',
    bakimZorlugu: 'Kolay',
    konum: 'Arka plan',
    aciklama: 'Uzun dar yaprakları ile zarif görünüm sağlar.'
  },
  {
    id: 'hygrophila-difformis',
    isim: 'Çınar Bitkisi',
    latince: 'Hygrophila difformis',
    resim: '/images/bitkiler/hygrophila-difformis.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Güneydoğu Asya',
    uzunluk: '20-50 cm',
    genislik: '15-25 cm',
    sicaklik: '22-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Çok hızlı',
    bakimZorlugu: 'Çok kolay',
    konum: 'Arka plan',
    aciklama: 'Parçalı yaprakları çınar yaprağını andırır. Çok hızlı büyür.'
  },
  {
    id: 'lobelia-cardinalis',
    isim: 'Kardinal Çiçeği',
    latince: 'Lobelia cardinalis',
    resim: '/images/bitkiler/lobelia-cardinalis.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Kuzey Amerika',
    uzunluk: '15-30 cm',
    genislik: '5-10 cm',
    sicaklik: '18-26°C',
    ph: '6.5-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta',
    co2Ihtiyaci: 'Opsiyonel',
    buyumeHizi: 'Yavaş - Orta',
    bakimZorlugu: 'Kolay',
    konum: 'Orta plan',
    aciklama: 'Açık yeşil yaprakları ve kompakt büyümesi ile popüler.'
  },
  {
    id: 'lysimachia-nummularia',
    isim: 'Altın Para Bitkisi',
    latince: 'Lysimachia nummularia Aurea',
    resim: '/images/bitkiler/lysimachia-nummularia.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Avrupa',
    uzunluk: '20-50 cm',
    genislik: '3-5 cm',
    sicaklik: '15-25°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta',
    co2Ihtiyaci: 'Opsiyonel',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Kolay',
    konum: 'Orta - Arka plan',
    aciklama: 'Altın sarısı yuvarlak yaprakları ile dikkat çeker.'
  },
  {
    id: 'cardamine-lyrata',
    isim: 'Japon Tere',
    latince: 'Cardamine lyrata',
    resim: '/images/bitkiler/cardamine-lyrata.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Doğu Asya',
    uzunluk: '20-50 cm',
    genislik: '10-15 cm',
    sicaklik: '15-23°C',
    ph: '6.5-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta',
    co2Ihtiyaci: 'Opsiyonel',
    buyumeHizi: 'Hızlı',
    bakimZorlugu: 'Kolay',
    konum: 'Orta - Arka plan',
    aciklama: 'Serin su sever. Düğümlerden adventif kökler çıkarır.'
  },
  {
    id: 'cabomba-caroliniana',
    isim: 'Cabomba',
    latince: 'Cabomba caroliniana',
    resim: '/images/bitkiler/cabomba-caroliniana.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Kuzey ve Güney Amerika',
    uzunluk: '30-80 cm',
    genislik: '5-8 cm',
    sicaklik: '20-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta',
    co2Ihtiyaci: 'Opsiyonel',
    buyumeHizi: 'Hızlı',
    bakimZorlugu: 'Orta',
    konum: 'Arka plan',
    aciklama: 'İnce tüylü yaprakları ile zarif görünüm. Orta ışık sever.'
  },
  {
    id: 'lagarosiphon-major',
    isim: 'Afrika Elodeası',
    latince: 'Lagarosiphon major',
    resim: '/images/bitkiler/lagarosiphon-major.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Güney Afrika',
    uzunluk: '40-100 cm',
    genislik: '3-5 cm',
    sicaklik: '15-24°C',
    ph: '6.5-8.0',
    sertlik: 'Orta - Sert',
    isikIhtiyaci: 'Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Hızlı',
    bakimZorlugu: 'Kolay',
    konum: 'Arka plan',
    aciklama: 'Kıvrık yapraklı, elodeaya benzer görünüm. Serin su sever.'
  },
  {
    id: 'shinnersia-rivularis',
    isim: 'Meksika Meşe Yaprağı',
    latince: 'Shinnersia rivularis',
    resim: '/images/bitkiler/shinnersia-rivularis.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Meksika',
    uzunluk: '30-60 cm',
    genislik: '8-12 cm',
    sicaklik: '20-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Hızlı',
    bakimZorlugu: 'Kolay',
    konum: 'Arka plan',
    aciklama: 'Meşe yaprağı şeklinde yaprakları ile tanınır.'
  },
  {
    id: 'gymnocoronis-spilanthoides',
    isim: 'Su Krizantemi',
    latince: 'Gymnocoronis spilanthoides',
    resim: '/images/bitkiler/gymnocoronis-spilanthoides.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Güney Amerika',
    uzunluk: '30-60 cm',
    genislik: '10-15 cm',
    sicaklik: '20-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Çok hızlı',
    bakimZorlugu: 'Kolay',
    konum: 'Arka plan',
    aciklama: 'Geniş yapraklı, çok hızlı büyüyen bitki.'
  },

  // ==================== MID TECH ====================
  {
    id: 'rotala-rotundifolia',
    isim: 'Rotala',
    latince: 'Rotala rotundifolia',
    resim: '/images/bitkiler/rotala-rotundifolia.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Güneydoğu Asya',
    uzunluk: '15-30 cm',
    genislik: '2-3 cm',
    sicaklik: '22-28°C',
    ph: '5.5-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Opsiyonel',
    buyumeHizi: 'Hızlı',
    bakimZorlugu: 'Orta',
    konum: 'Orta - Arka plan',
    aciklama: 'Yüksek ışıkta pembe-kırmızı renk alır. Çok popüler bitki.'
  },
  {
    id: 'rotala-sp-green',
    isim: 'Yeşil Rotala',
    latince: 'Rotala sp. Green',
    resim: '/images/bitkiler/rotala-sp-green.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Güneydoğu Asya',
    uzunluk: '20-40 cm',
    genislik: '2-3 cm',
    sicaklik: '22-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta',
    co2Ihtiyaci: 'Opsiyonel',
    buyumeHizi: 'Hızlı',
    bakimZorlugu: 'Orta',
    konum: 'Orta - Arka plan',
    aciklama: 'Parlak yeşil yaprakları ile güzel bir arka plan oluşturur.'
  },
  {
    id: 'rotala-sp-nanjenshan',
    isim: 'Nanjenshan Rotala',
    latince: 'Rotala sp. Nanjenshan',
    resim: '/images/bitkiler/rotala-sp-nanjenshan.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Tayvan',
    uzunluk: '10-25 cm',
    genislik: '2-4 cm',
    sicaklik: '22-28°C',
    ph: '5.5-7.0',
    sertlik: 'Yumuşak',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Orta',
    konum: 'Orta plan',
    aciklama: 'İnce iğne yapraklı, zarif görünümlü bitki.'
  },
  {
    id: 'rotala-sp-vietnam',
    isim: 'Vietnam Rotalası',
    latince: 'Rotala sp. Vietnam',
    resim: '/images/bitkiler/rotala-sp-vietnam.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Vietnam',
    uzunluk: '10-20 cm',
    genislik: '3-5 cm',
    sicaklik: '22-28°C',
    ph: '5.5-7.0',
    sertlik: 'Yumuşak',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Yavaş - Orta',
    bakimZorlugu: 'Orta',
    konum: 'Orta plan',
    aciklama: 'Kırmızımsı yaprakları ve kompakt büyümesi ile dikkat çeker.'
  },
  {
    id: 'rotala-sp-bonsai',
    isim: 'Cüce Bonsai Rotala',
    latince: 'Rotala sp. Bonsai',
    resim: '/images/bitkiler/rotala-sp-bonsai.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Asya',
    uzunluk: '3-8 cm',
    genislik: '2-4 cm',
    sicaklik: '22-28°C',
    ph: '5.5-7.0',
    sertlik: 'Yumuşak',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Yavaş',
    bakimZorlugu: 'Orta',
    konum: 'Ön plan',
    aciklama: 'Minyatür boyutu ile ön plan için ideal. Yavaş büyür.'
  },
  {
    id: 'ludwigia-repens',
    isim: 'Gül Bitkisi',
    latince: 'Ludwigia repens',
    resim: '/images/bitkiler/ludwigia-repens.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Kuzey Amerika',
    uzunluk: '20-50 cm',
    genislik: '5-8 cm',
    sicaklik: '20-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Opsiyonel',
    buyumeHizi: 'Hızlı',
    bakimZorlugu: 'Kolay - Orta',
    konum: 'Orta - Arka plan',
    aciklama: 'Yüksek ışıkta yapraklar kırmızıya döner. Dayanıklı bitki.'
  },
  {
    id: 'ludwigia-repens-rubin',
    isim: 'Rubin Ludwigia',
    latince: 'Ludwigia repens Rubin',
    resim: '/images/bitkiler/ludwigia-repens-rubin.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Kuzey Amerika (Kültür formu)',
    uzunluk: '20-50 cm',
    genislik: '5-8 cm',
    sicaklik: '22-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Orta',
    konum: 'Orta - Arka plan',
    aciklama: 'Koyu kırmızı yaprakları ile çok dekoratif.'
  },
  {
    id: 'ludwigia-palustris',
    isim: 'Bataklık Ludwigiası',
    latince: 'Ludwigia palustris',
    resim: '/images/bitkiler/ludwigia-palustris.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Amerika, Avrupa',
    uzunluk: '15-30 cm',
    genislik: '4-6 cm',
    sicaklik: '18-26°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta',
    co2Ihtiyaci: 'Opsiyonel',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Orta',
    konum: 'Orta plan',
    aciklama: 'Kompakt büyüyen, kırmızımsı yeşil yapraklı.'
  },
  {
    id: 'ludwigia-arcuata',
    isim: 'Kavisli Ludwigia',
    latince: 'Ludwigia arcuata',
    resim: '/images/bitkiler/ludwigia-arcuata.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Kuzey Amerika',
    uzunluk: '15-30 cm',
    genislik: '3-5 cm',
    sicaklik: '22-28°C',
    ph: '5.5-7.0',
    sertlik: 'Yumuşak',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Orta',
    konum: 'Orta plan',
    aciklama: 'İnce kavisli yaprakları ile zarif görünüm.'
  },
  {
    id: 'ludwigia-brevipes',
    isim: 'Kısa Saplı Ludwigia',
    latince: 'Ludwigia brevipes',
    resim: '/images/bitkiler/ludwigia-brevipes.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Kuzey Amerika',
    uzunluk: '15-30 cm',
    genislik: '3-5 cm',
    sicaklik: '22-28°C',
    ph: '5.5-7.0',
    sertlik: 'Yumuşak',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Orta',
    konum: 'Orta plan',
    aciklama: 'Sarı-turuncu yaprak uçları ile renkli bitki.'
  },
  {
    id: 'ludwigia-ovalis',
    isim: 'Oval Ludwigia',
    latince: 'Ludwigia ovalis',
    resim: '/images/bitkiler/ludwigia-ovalis.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Doğu Asya',
    uzunluk: '20-40 cm',
    genislik: '4-6 cm',
    sicaklik: '22-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta',
    co2Ihtiyaci: 'Opsiyonel',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Orta',
    konum: 'Orta - Arka plan',
    aciklama: 'Yuvarlak yaprakları ve pembe tonları ile güzel.'
  },
  {
    id: 'limnophila-aquatica',
    isim: 'Dev Ambulia',
    latince: 'Limnophila aquatica',
    resim: '/images/bitkiler/limnophila-aquatica.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Güneydoğu Asya',
    uzunluk: '30-50 cm',
    genislik: '8-12 cm',
    sicaklik: '22-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Hızlı',
    bakimZorlugu: 'Orta',
    konum: 'Arka plan',
    aciklama: 'Çok dekoratif, tüylü yapraklı büyük bitki.'
  },
  {
    id: 'limnophila-aromatica',
    isim: 'Aromatik Limnofila',
    latince: 'Limnophila aromatica',
    resim: '/images/bitkiler/limnophila-aromatica.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Güneydoğu Asya',
    uzunluk: '20-40 cm',
    genislik: '5-8 cm',
    sicaklik: '22-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Orta',
    konum: 'Orta - Arka plan',
    aciklama: 'Hoş kokulu, mor-yeşil yapraklı dekoratif bitki.'
  },
  {
    id: 'heteranthera-zosterifolia',
    isim: 'Yıldız Çimi',
    latince: 'Heteranthera zosterifolia',
    resim: '/images/bitkiler/heteranthera-zosterifolia.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Güney Amerika',
    uzunluk: '30-50 cm',
    genislik: '8-15 cm',
    sicaklik: '22-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Hızlı',
    bakimZorlugu: 'Orta',
    konum: 'Orta - Arka plan',
    aciklama: 'Yıldız şeklinde yaprak dizilimi ile çok dekoratif.'
  },
  {
    id: 'hydrocotyle-leucocephala',
    isim: 'Brezilya Su Göbeği',
    latince: 'Hydrocotyle leucocephala',
    resim: '/images/bitkiler/hydrocotyle-leucocephala.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Güney Amerika',
    uzunluk: '20-60 cm',
    genislik: '10-15 cm',
    sicaklik: '20-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta',
    co2Ihtiyaci: 'Opsiyonel',
    buyumeHizi: 'Hızlı',
    bakimZorlugu: 'Kolay - Orta',
    konum: 'Orta - Arka plan / Yüzen',
    aciklama: 'Yuvarlak yaprakları ile ilginç görünüm. Yüzeye de çıkabilir.'
  },
  {
    id: 'hydrocotyle-tripartita',
    isim: 'Japon Yoncası',
    latince: 'Hydrocotyle tripartita',
    resim: '/images/bitkiler/hydrocotyle-tripartita.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Güneydoğu Asya',
    uzunluk: '5-15 cm',
    genislik: '10-20 cm',
    sicaklik: '22-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Hızlı',
    bakimZorlugu: 'Orta',
    konum: 'Ön - Orta plan',
    aciklama: 'Yonca benzeri yaprakları ile popüler zemin bitkisi.'
  },
  {
    id: 'hydrocotyle-verticillata',
    isim: 'Şemsiye Bitkisi',
    latince: 'Hydrocotyle verticillata',
    resim: '/images/bitkiler/hydrocotyle-verticillata.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Amerika',
    uzunluk: '5-15 cm',
    genislik: '3-5 cm',
    sicaklik: '20-26°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Orta',
    konum: 'Ön plan',
    aciklama: 'Mantar şapkası gibi yaprakları ile ilginç görünüm.'
  },
  {
    id: 'hydrocotyle-sibthorpioides',
    isim: 'Cüce Su Göbeği',
    latince: 'Hydrocotyle sibthorpioides',
    resim: '/images/bitkiler/hydrocotyle-sibthorpioides.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Asya',
    uzunluk: '2-5 cm',
    genislik: '5-10 cm',
    sicaklik: '20-26°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Orta',
    konum: 'Ön plan',
    aciklama: 'Çok küçük yaprakları ile zemin kaplama bitkisi.'
  },
  {
    id: 'hygrophila-pinnatifida',
    isim: 'Parçalı Hygrophila',
    latince: 'Hygrophila pinnatifida',
    resim: '/images/bitkiler/hygrophila-pinnatifida.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Hindistan',
    uzunluk: '15-40 cm',
    genislik: '10-20 cm',
    sicaklik: '22-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Yavaş - Orta',
    bakimZorlugu: 'Orta',
    konum: 'Orta plan',
    aciklama: 'Parçalı yaprakları ve kahverengi tonları ile benzersiz.'
  },
  {
    id: 'staurogyne-repens',
    isim: 'Staurogyne',
    latince: 'Staurogyne repens',
    resim: '/images/bitkiler/staurogyne-repens.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Güney Amerika',
    uzunluk: '5-10 cm',
    genislik: '5-10 cm',
    sicaklik: '22-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Yavaş - Orta',
    bakimZorlugu: 'Orta',
    konum: 'Ön plan',
    aciklama: 'Kompakt büyüyen, ön plan için ideal zemin bitkisi.'
  },
  {
    id: 'didiplis-diandra',
    isim: 'Su Çalısı',
    latince: 'Didiplis diandra',
    resim: '/images/bitkiler/didiplis-diandra.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Kuzey Amerika',
    uzunluk: '10-30 cm',
    genislik: '3-5 cm',
    sicaklik: '20-26°C',
    ph: '5.5-7.0',
    sertlik: 'Yumuşak',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Yavaş - Orta',
    bakimZorlugu: 'Orta - Zor',
    konum: 'Ön - Orta plan',
    aciklama: 'İnce iğne yapraklı, yüksek ışıkta kırmızılaşır.'
  },
  {
    id: 'pogostemon-erectus',
    isim: 'Dik Pogostemon',
    latince: 'Pogostemon erectus',
    resim: '/images/bitkiler/pogostemon-erectus.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Hindistan',
    uzunluk: '20-40 cm',
    genislik: '3-5 cm',
    sicaklik: '22-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Orta',
    konum: 'Orta - Arka plan',
    aciklama: 'İğne benzeri yaprakları ile dikey büyür.'
  },
  {
    id: 'pogostemon-helferi',
    isim: 'Küçük Yıldız',
    latince: 'Pogostemon helferi',
    resim: '/images/bitkiler/pogostemon-helferi.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Tayland',
    uzunluk: '3-10 cm',
    genislik: '5-10 cm',
    sicaklik: '22-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Yavaş',
    bakimZorlugu: 'Orta',
    konum: 'Ön plan',
    aciklama: 'Yıldız şeklinde kıvrık yaprakları ile benzersiz.'
  }
];

export default govdeliBitkilerPart1;